import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {ServantVM, ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {CompanyService} from "../../services/company-service/company-service";
import {CompanyVM} from "../../models/CompanyVM.model";
import {ServantService} from "../../services/servant-service/servant-service";


@Component({
  selector: 'rw-servant-list', // <home></home>
  template: require('./servant-list.component.html'),
  styles: [require('./servant-list.component.css')],
  providers: []
})
export class ServantListComponent implements OnInit {

  // @Input() public serviceList:ServiceItemVM[];

  servantList: any;
  companyInfo: CompanyVM;
  selectedServant: ServantVM;
  servantServices: ServiceItemVM[];
  showServantServices: boolean = false;
  showServants: boolean = true;
  loading: boolean = false;
  isCardViewMode: boolean;
  servantId: number;

  constructor(public route: ActivatedRoute,
              public activatedRoute: ActivatedRoute,
              private companyService: CompanyService,
              private serviceOfServant: ServantService) {
    this.servantList = [];
    this.selectedServant = null;
    this.servantServices = [];
    //this.companyInfo = new CompanyVM();
  }

  public ngOnInit() {
    let parent = this;


    this.companyService.getCompanyInfo().subscribe(compInfo => {
      parent.companyInfo = compInfo;
      this.setServiceViewMode(compInfo);
      this.companyService.getCompanyServant(compInfo.id).subscribe(servant => {
        this.servantList = servant as ServantVM[];
        this.selectedServant = null;

        //check if there is parameter in the url(servant id)
        this.activatedRoute.queryParams.subscribe((params: Params) => {
          let id = params['id'];
          this.servantId = params['id'];

          if (id !== null && id !== undefined) {
            this.showServantServicesView();
            this.onServantUrlTypes(id);
          } else {
            this.showServantView()
          }
        });
      });
    })
  }

  setServiceViewMode(compInfo: CompanyVM) {

    this.isCardViewMode = false;
    if (compInfo.activityType != 'OTHER') {
      this.isCardViewMode = true;
    }
  }

  onServantClick(svt) {
    this.showLoading(true);

    this.selectedServant = svt;
    this.serviceOfServant.getService(this.selectedServant.id).subscribe(services => {
      this.goToTop();
      this.servantServices = services;
      this.showServantServicesView();
      this.showLoading(false);
    })
  }

  onServantUrlTypes(id) {
    this.showLoading(true);

    this.servantList.forEach(element => {
      if (+element.id === +id){
        this.selectedServant = element;
        this.serviceOfServant.getService(this.selectedServant.id).subscribe(services => {
          this.goToTop();
          this.servantServices = services;
          this.showServantServicesView();
          this.showLoading(false);
        })
      }
    });

  }

  showServantView() {
    this.showServants = true;
    this.showServantServices = false;
  }

  showServantServicesView() {
    this.showServants = false;
    this.showServantServices = true;
  }

  showLoading(p) {
    this.loading = p;
  }

  activeServants(list:any)
  {
    return list.filter(function(svt){
     return( svt.status !== 'NOT_ACTIVE');
    })
  }

  onServicesToServantsReturn() {
    this.selectedServant = null;
    this.showServantView();
  }

  goToTop() {
    window.scroll(0, 0);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/servant-list/servant-list.component.ts